import { Injectable } from '@angular/core';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MediaService {

  desktop$ = this.mediaObserver.asObservable().pipe(
    map((changes: MediaChange[]) => changes.some(change => change.mqAlias === 'gt-sm')),
    distinctUntilChanged(),
    shareReplay(1)
  );

  constructor(
    private mediaObserver: MediaObserver
  ) {}

}
